<template>
  <div class="dropdown" v-click-away="hideDropdown" :class="[ extraCssClass ]" v-cloak>
    <a class="dropdown__link dropdown__link--checkbox link--no-hover" @click="toggleDropdown()" :class="{'dropdown__link--checkbox-show' : show}" ref="dropdownLink">
      <ul v-if="checkedOptions.length > 0" class="dropdown__tags">
        <li v-for="option in checkedOptions">{{option}}
          <a href="#" @click.prevent="removeSelectedOption(option)"><i class="icon icon--cross"></i></a>
        </li>
      </ul>
      <span class="dropdown__selected" :class="{'dropdown__selected--district': options.length === 0}" v-if="checkedOptions.length === 0">
        {{ emptyString }}
      </span>
      <i class="icon " :class="[ show ? 'icon--flipped' : '', iconClass ]"></i>
    </a>
    <transition name="fade">
      <div class="dropdown__holder dropdown__holder--checkbox" v-if="show" v-cloak id="dropdownHolder">
        <ul class="dropdown__list">
          <li class="dropdown__list-item dropdown__list-item--checkbox">
            <div class="checkbox-custom" v-if="options.length > 0">
              <input type="checkbox" class="subscribe" id="selectAll" name="option-checkbox" value="all" @click="selectAll" v-model="inputSelectAll">
              <label class="form-check-label" for="selectAll">All Suburbs</label>
            </div>
          </li>
          <li v-for="option in options" class="dropdown__list-item dropdown__list-item--checkbox" :class="{ 'dropdown__list-item--active': options.length === 0 }">
            <div class="checkbox-custom">
              <input type="checkbox" class="subscribe" :id="option.key" name="option-checkbox" :value="option.value" v-model="checkedOptions" >
              <label class="form-check-label" :for="option.key">{{ option.value }}</label>
            </div>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>
<script setup>
  import axios from 'axios'
  import {nextTick, onMounted, ref, watch} from 'vue'
  import useFilterStore from '../../store/filterStore'


  const filterStore = useFilterStore()
  const props = defineProps({
    emptyString: {
      default: 'Select an option',
    },
    districtId: {
      default: 0,
    },
    defaultCheckedOptions: {
      type: Array,
      default: () => [],
    },
    iconClass: {
      default: 'icon--down',
    },
    extraCssClass: {
      type: String,
    },
  });

  const show = ref(false);
  const selectedOptionId = ref(parseInt(props.defaultSelectedId, 10));
  const inputSelectAll = ref(false);
  const clickTag = ref(false);
  const allSelected = ref(false);
  const checkedOptions = ref(props.defaultCheckedOptions);
  const options = ref([]);
  const dropdownLink = ref(null);

  const fetchData = async (newDistrict) => {
    axios.get(`/filter-suburbs/${newDistrict.id}`).then((response) => {
      options.value = response.data;
    });
  };

  watch(
    () => filterStore.district,
    async (newDistrict) => {
      await fetchData(newDistrict);
    }
  );

  const selectAll = () => {
    checkedOptions.value = [];
    allSelected.value = !allSelected.value;
    if (allSelected.value) {
      for (let x in options.value) {
        checkedOptions.value.push(options.value[x].value);
      }
    }
  }

  const toggleDropdown = async () => {
    if (!clickTag.value) {
      show.value = !show.value;
      if (show.value) {
        await nextTick()
        const height = parseInt(dropdownLink.value.clientHeight, 10) + 1;
        document.getElementById('dropdownHolder').style.top = `${height}px`;
      }
    } else {
      clickTag.value = false;
    }
  }

  const hideDropdown = () => {
    if (show.value) {
      show.value = false;
    }
  }

  const removeSelectedOption = (optionName) => {
    const index = checkedOptions.value.indexOf(optionName);
    if (index > -1) {
      checkedOptions.value.splice(index, 1);
    }
    clickTag.value = true;
    inputSelectAll.value = false;
    allSelected.value = false;
  }

  watch(
    () => checkedOptions.value,
    (newOptions) => {
      filterStore.suburbs = newOptions;

      if (newOptions.length > 0) {
        inputSelectAll.value = false;
      }
    }
  );

  onMounted(() => {
    // const district = props.districtId;
    // if (district && district !== '0') {
    //   axios.get(`/filter-suburbs/${district}`).then((response) => {
    //     options.value = response.data;
    //   });
    // }
  });
</script>
